// extracted by mini-css-extract-plugin
export default {"feedContainer":"U8I1kUpY_T","posts":"quwsCdNsPR"};